import Input from "../../Customer/Component/Input";


export const carepackagesInput = [
  {
    tag: Input,
    label: "Care Package Name",
    name: "packageName",
    validation: "required",
    required: true,
  },

  {
    tag: Input,
    label: "Price(₹)",
    name: "price",
    validation: "required",
    required: true,
  },
  {
    tag: Input,
    label: "Discount[%]",
    name: "discount",
    validation: "required",
    required: true,
  },
  
  {
    tag: Input,
    label: "Terms And Condition",
    name: "termsAndCondition",
    validation: "required",
    required: true,
  },
];
